import React, {Component} from "react";
import {
    View,
    FlatList,
    ActivityIndicator, Platform, KeyboardAvoidingView, TouchableOpacity, Alert, BackHandler, ScrollView, I18nManager
} from "react-native";
import styles from "../../../../styles/DetialsAdversingMainStyles";
import EmptyView from "../../../../customviews/empty/EmptyView";
import Colors from "../../../../tools/Colors";
import DialogConnectionCustomize from "../../../../customviews/DialogConnectionCustomize";
import i18n from "../../../../I18n/i18n";
import {typeExport} from "../../../../redux/store/type";
import store from "../../../../redux/store";
import {
    serviceActionAddSubList,
    serviceActionListFilter,
    serviceActionSuccess,
    serviceActionError
} from "./action/ActionListOnlineChargingHistorySatiaScreen";
import {moderateScale} from "../../../../tools/Scaling";
import HMTextView from "../../../../customviews/HMTextView";
import {Tools} from "../../../../tools/Tools";
import HMDialogSelectDate from "../../../../customviews/HMDialogSelectDate";
import HMActionBarSatia from "../../../../customviews/HMActionBarSatia";
import HMButton from "../../../../customviews/HMButton";
import HMIcon from "../../../../customviews/HMIcon";

let container = null;
export default class ListOnlineChargingHistorySatiaScreen extends Component {
    constructor(props) {
        super(props);
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;
        let lat = 0
        let long = 0
        if (!myLocation) {
            lat = parseFloat(myLocation ? myLocation.coords.latitude : 0);
            long = parseFloat(myLocation ? myLocation.coords.longitude : 0);
            // long = parseFloat(props.navigation && props.route.params ? props.route.params.position.coords.longitude : props.position ? props.position.coords.longitude : 0);

        }
        this.state = {
            Period: null,
            indexSelectType: -1,
            listFilter: [],
            //  indexSelectParent:0,
            token: "359601088562055",
            checkPushResultOffline: false,
            textMenu: "پیام های ارسال شده",
            indexMenu: 0,
            visibleModal: '',
            indexFilter: 0,

            lat: lat,
            long: long,
            dataSourcearrayCondition: [{name: 'ثبت شد', id: 1}, {
                name: 'در دست اقدام',
                id: 2
            }, {name: 'تکراری در دست اقدام', id: 3}, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {
                name: 'تایید واحد',
                id: 5
            },],
            textCondition: null,
            arrayCondition: [{name: 'ثبت شد', id: 1}, {name: 'در دست اقدام', id: 2}, {
                name: 'تکراری در دست اقدام',
                id: 3
            }, {name: 'مربوط به این منطقه نمی باشد', id: 4}, {name: 'تایید واحد', id: 5},],
            Condition: {id: 0, value: "وضعیت پیام"},

            arrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            textOperational_Unit: null,
            dataSourcearrayOperational_Unit: [{name: 'عمران منطقه ۱', id: 1}, {name: 'مسپول رسیدگی ۱۸۸۸', id: 2}],
            Operational_Unit: {id: 0, value: "واحد اجرایی"},

            arraySelected: [],
            trackingCode: null

        };
        container = this;

        store.dispatch(serviceActionListFilter([]))
        this.props.callserviceActionRefresh();
        this.getData(1)
        // this.props.navigation.addListener('focus', () => {
        //      /*   store.dispatch(serviceActionListFilter([]))
        //         props.callserviceActionRefresh();
        //         this.getData(1)*/
        //     }
        // )
        // this.props.navigation.addListener('blur', () => {}
        // )

    }

    state = {
        show: false
    };

    componentWillReceiveProps(propss) {


    }

    async componentDidMount() {

    }

    componentWillUnmount() {

    }

    async getData(page) {
        //  let {item, data} = this.props.route.params

        let after = "0000-00-00";
        //   this.props.callService(urlListOnlineChargingHistorySatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListOnlineChargingHistorySatiaScreen, 'POST',page,this.props.item_count)
        // this.props.callService(typeExport.urlListOnlineChargingHistorySatiaScreen, `?lang=${i18n.locale}&token=${this.props.DataSplashScreen.token}`, typeExport.TypeGetListOnlineChargingHistorySatiaScreen, 'POST', page, 10)
        /*  let paramss = {
              "id": 1,
              "lang": i18n.locale,
              "imei": 0,
              "page": page,
               "after": "0000-00-00"
          };
          this.props.callService(this.props.route.params.item.link_url, paramss, typeExport.TypeGetListOnlineChargingHistorySatiaScreen, _GET, page, 10)
  */

        let paramss = {
            "_operation": typeExport._Fire,

            "mode": typeExport._GetDashboard,
            "lang": i18n.locale,
            "_session": store.getState().reducerSplashSatiaScreen.token,
            "page": page,
            "month": this.state.Period,
            //  beginDate=1399/5/24&endDate=1399/6/13
            //     DateTo={this.state.DateTo}
            // DateFrom={this.state.DateFrom}
            // "beginDate": this.state.DateTo,
            // "endDate": this.state.DateFrom,
            "beginDate": this.state.DateFrom,
            "endDate": this.state.DateTo,
        };
        if (store.getState().reducerSplashSatiaScreen.Connection) {

            this.props.callService(typeExport._baseUrlSatia + "services/ChargingHistory", paramss, typeExport.TypeGetListOnlineChargingHistorySatiaScreen, typeExport._POST, page, typeExport._Count, null)

        } else {
            // let data = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatia + item.type)
            // let listFilter = await AsyngStorageClass.getASyng(global.IdCity + typeExport.ListServiceHistorySatiaFilter + item.type)
            // store.dispatch(serviceActionListFilter(listFilter))
            // if (data != null)
            //     store.dispatch(serviceActionSuccess(data, 0))
            // else
            //     store.dispatch(serviceActionSuccess([], 0))

            store.dispatch(serviceActionError('not connection', 1))
        }

    }

    _menu = null;

    setMenuRef = ref => {
        this._menu = ref;
    };
    hideMenu = (item, key) => {
        this.setState({
            textMenu: item.title,
            indexMenu: key
        })
        this._menu.hide();
    };

    showMenu = () => {
        this._menu.show();
    };

    _onMapReady = () => this.setState({marginBottom: 0})

    render() {
        //     let {item} = this.props.item ? this.props : this.props.route.params;
        let item = this.props.navigation && this.props.route && this.props.route.params ? this.props.route.params.item : this.props.item;
        let myLocation = store.getState().reducerSplashSatiaScreen.Location;

        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        // let childFilter = result.items[this.state.indexFilter].list;
        //let childFilter = this.props.ListFilter && this.props.ListFilter.length > 0 ? this.props.ListFilter[this.state.indexFilter] : [];
        return (
            <View style={{position: 'relative', flex: 1,}}>


                {/*<HMImageBackground*/}

                {/*/>*/}

                <View style={{position: 'absolute', top: 0, bottom: 0, left: 0, right: 0}}>
                    <KeyboardAvoidingView style={{width: "100%", height: "100%"}} behavior={"padding"}
                                          enabled={Platform.OS === "ios"}>

                        {
                            this.props.item ?
                                null
                                :
                                <HMActionBarSatia
                                    //exit={true}
                                    menu
                                    back

                                    props={this.props} statusBarTransparent
                                    // text={i18n.t('ListServiceHistorySatia.title')}
                                    text={(item && item.name ? item.name : (item && item.title ? item.title : 'سوابق خرید آنلاین'))}
                                    //text={(data.name ? data.name : (data.title ? data.title : ''))}
                                    //  text={this.state.arraySelected.length}


                                    //  text={i18n.t('constant.Information')}

                                    headerVisibility more_menu
                                    onBackPress={() => this.props.navigation.pop()}

                                />
                        }

                        <View style={{flex: 1}}>



                            <View style={{flex: 1}}>

                                <View style={{flex: 1}}>
                                    <EmptyView empty={this.props.empty}/>

                                    <FlatList
                                        data={this.props.results ? this.props.results : []}

                                        renderItem={({item, index}) => {

                                            if (item.service)
                                                return (<View
                                                    style={{
                                                        flex: 1,
                                                        overflow: 'hidden',
                                                        //height:  moderateScale(100),
                                                        // padding: moderateScale(4),
                                                        margin: moderateScale(5),
                                                        borderWidth: moderateScale(1),
                                                        borderRadius: moderateScale(2),
                                                        borderColor: '#ddd',
                                                        borderBottomWidth: 0,
                                                        shadowColor: '#000',
                                                        shadowOffset: {width: 0, height: moderateScale(.7)},
                                                        shadowOpacity: 0.6,
                                                        shadowRadius: moderateScale(2),
                                                        elevation: moderateScale(1),
                                                        // marginLeft: moderateScale(1),
                                                        // marginRight: moderateScale(1),
                                                        // marginTop: moderateScale(1),
                                                        // marginBottom: moderateScale(1),
                                                        backgroundColor: item.background_color ? item.background_color : Colors.white,
                                                    }}>
                                                    <View
                                                        style={{
                                                            width: "98%",
                                                            //  backgroundColor: item.IbsCode == 1 ? Colors.green : Colors.redLight,
                                                            // backgroundColor: item.ColorStatus ? item.ColorStatus : Colors.gray,

                                                            flexDirection: 'row',
                                                            padding: moderateScale(6),
                                                        }}>

                                                        <View
                                                            style={{
                                                                flex: .2,
                                                                //backgroundColor: "#eeec44"
                                                            }}>
                                                            <View style={{
                                                                //  backgroundColor: "#26ee22"
                                                            }}>
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={item.Date}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDarkText,
                                                                        fontSize: moderateScale(14),


                                                                    }}/>
                                                            </View>
                                                            <View style={{
                                                                //backgroundColor: "#1592ee",
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                marginTop: moderateScale(6)
                                                            }}>
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={"شماره پیگیری"}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDarkText,
                                                                        fontSize: moderateScale(14),


                                                                    }}/>
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={item.Serial}
                                                                    type={"bold"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        color: Colors.colorDarkText,
                                                                        fontSize: moderateScale(14),


                                                                    }}/>
                                                            </View>
                                                        </View>
                                                        <View style={{width: moderateScale(4)}}/>
                                                        <View
                                                            style={{
                                                                flex: .8,
                                                                //backgroundColor: "#ee19aa"
                                                            }}>
                                                            <View style={{
                                                                flexDirection: 'row',
                                                                //backgroundColor: "#eee970"
                                                            }}>
                                                                <View style={{
                                                                    flex: .82,
                                                                    //  paddingHorizontal: moderateScale(2)
                                                                    //backgroundColor: "#ee19aa"
                                                                }}>
                                                                    <HMTextView
                                                                        //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                        text={item.service ? item.service.Name : ""}
                                                                        type={"bold"}
                                                                        style={{
                                                                            // textAlign: "center",
                                                                            color: Colors.blackLight,
                                                                            fontSize: moderateScale(14),


                                                                        }}/>
                                                                </View>

                                                                <View style={{
                                                                    flex: .18,
                                                                    alignItems: 'flex-end',
                                                                    // paddingHorizontal: moderateScale(4)
                                                                    //  justifyContent:'center'
                                                                }}>
                                                                    <TouchableOpacity style={{
                                                                        width: "100%",
                                                                        backgroundColor: item.ColorStatus ? item.ColorStatus : Colors.gray,
                                                                        alignItems: 'center',
                                                                        padding: moderateScale(2),
                                                                        borderRadius: moderateScale(4)
                                                                    }}>
                                                                        <HMTextView
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={item.Status}
                                                                            type={"bold"}
                                                                            style={{
                                                                                textAlign: "center",
                                                                                color: Colors.white,
                                                                                fontSize: moderateScale(14),


                                                                            }}/>
                                                                    </TouchableOpacity>
                                                                </View>
                                                            </View>
                                                            <View style={{
                                                                //  backgroundColor: "#b07bee"
                                                            }}>
                                                                <HMTextView
                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                    text={item.Type}
                                                                    type={"bold"}
                                                                    style={{
                                                                        //  textAlign: "center",
                                                                        color: Colors.colorDark,
                                                                        fontSize: moderateScale(14),


                                                                    }}/>
                                                                {
                                                                    item.IbsCode == "0" ?
                                                                        <View style={{
                                                                            flex: 1,
                                                                            flexDirection: 'row',
                                                                            flexWrap: 'wrap',
                                                                        }}>
                                                                            <HMTextView
                                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                text={item.Description1}
                                                                                //text={ "در صورتی که مبلغ از حساب شما کسر شده تا 72 ساعت عودت می شود چنانچه عودت نگردید با پشتیبانی "}
                                                                                type={"bold"}
                                                                                style={{
                                                                                    //  textAlign: "center",
                                                                                    color: Colors.gray,
                                                                                    fontSize: moderateScale(14),


                                                                                }}/>
                                                                            <TouchableOpacity
                                                                                onPress={() => {
                                                                                    // Platform.OS==='ios'?
                                                                                    Tools.GoLink(item.Url ? item.Url : "http://www.satiaisp.com/banksupport")
                                                                                    //  :
                                                                                    //  NavigationService.navigateParams("WebViewScreen", {
                                                                                    //     item: {
                                                                                    //         title: "پشتیبانی بانک ها",
                                                                                    //         external_url: "http://www.satiaisp.com/banksupport"
                                                                                    //     }
                                                                                    // })
                                                                                }}
                                                                            >
                                                                                <HMTextView
                                                                                    //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                    text={item.Bank}
                                                                                    type={"bold"}
                                                                                    style={{
                                                                                        //  textAlign: "center",
                                                                                        color: Colors.blue,
                                                                                        textDecorationLine: "underline",

                                                                                        fontSize: moderateScale(14),
                                                                                    }}/>
                                                                            </TouchableOpacity>
                                                                            <HMTextView
                                                                                //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                                text={item.Description2}

                                                                                //   text={ " تماس بگیرید."}
                                                                                type={"bold"}
                                                                                style={{
                                                                                    //  textAlign: "center",
                                                                                    color: Colors.gray,
                                                                                    fontSize: moderateScale(14),


                                                                                }}/>
                                                                        </View>
                                                                        :
                                                                        <HMTextView
                                                                            //text={this.props.resultsSetCommentScreen === null ? '' : this.props.resultsSetCommentScreen.message}
                                                                            text={item.Description}
                                                                            type={"bold"}
                                                                            style={{
                                                                                //  textAlign: "center",
                                                                                color: Colors.gray,
                                                                                fontSize: moderateScale(14),


                                                                            }}/>
                                                                }


                                                            </View>
                                                        </View>
                                                    </View>

                                                </View>)
                                            else
                                                return null
                                        }}
                                        keyExtractor={(item, index) => index.toString()}
                                        ListEmptyComponent={() =>
                                            null}
                                        // ItemSeparatorComponent={this.renderSeparator.bind(this)}
                                        ListFooterComponent={this.renderFooter.bind(this)}
                                        refreshing={this.props.showRefresh}
                                        onRefresh={this.handleRefresh.bind(this)}
                                        onEndReached={this.handleLoadMore.bind(this)}
                                        initialNumToRender={typeExport._Count-1}   onEndReachedThreshold={typeExport.LevelonEndReachedThreshold}
                                    />
                                </View>
                                <TouchableOpacity
                                    onPress={() => {
                                        this.setState({
                                            showDialogDate: true
                                        })
                                    }}
                                    style={{
                                        position: 'absolute',
                                        bottom: 0,
                                        overflow: 'hidden',
                                        width: moderateScale(48),
                                        height: moderateScale(48),
                                        borderRadius: moderateScale(24),
                                        // padding: moderateScale(4),
                                        margin: moderateScale(5),
                                        borderWidth: moderateScale(1),
                                        borderColor: '#ddd',
                                        borderBottomWidth: 0,
                                        shadowColor: '#000',
                                        shadowOffset: {width: 0, height: moderateScale(.7)},
                                        shadowOpacity: 0.6,
                                        shadowRadius: moderateScale(2),
                                        elevation: moderateScale(1),
                                        // marginLeft: moderateScale(1),
                                        // marginRight: moderateScale(1),
                                        // marginTop: moderateScale(1),
                                        // marginBottom: moderateScale(1),
                                        backgroundColor: Colors.colorSecondPrimary,
                                        alignItems: 'center',
                                        justifyContent: "center",
                                        zIndex: 1
                                    }}>
                                    <HMIcon type={"FontAwesome"} name="calendar" style={{
                                        color: Colors.white,
                                        fontSize: moderateScale(24),
                                        padding: moderateScale(4),
                                        alignSelf: "center",
                                    }}/>
                                </TouchableOpacity>

                                {
                                    this.props.NoInternetDialog ?
                                        <DialogConnectionCustomize
                                            onPress={() => this.getData(this.props.page)}/> : null
                                }
                                {
                                    this.state.showDialogDate ?
                                        <HMDialogSelectDate
                                            DateTo={this.state.DateTo}
                                            DateFrom={this.state.DateFrom}
                                            onPressOk={this.setDate}
                                            onPressCancel={() => {
                                                this.setState({
                                                    showDialogDate: false
                                                })
                                            }}
                                        />

                                        :

                                        null
                                }


                            </View>
                        </View>

                    </KeyboardAvoidingView>
                </View>
            </View>
        );
    }

    setDate(DateFrom, DateTo) {

        container.setState({
                DateFrom, DateTo, showDialogDate: false,
                indexSelectType: container.state.indexSelectTypePrevious,

            },
            () => {
                container.getData(1)
            }
        )
    }

    renderItem = ({item, index}) => {
        return <View/>
    }

    checkSelect(item, index) {
        let l = container.state["selectFilter" + index];

        return l && l.id != 0
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.id !== 0
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.id !== 0
        //
        //     default:
        //
        // }
    }

    SelectNameFilter(item, index) {
        //let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar

        let l = this.state["selectFilter" + index]

        return l && l.value ? l.value : item.name
        // switch (index) {
        //     case 0:
        //
        //         return this.state.Condition.value
        //
        //     case 1:
        //
        //         return this.state.Operational_Unit.value
        //
        //     default:
        //
        // }
    }

    renderItemFilter = ({item, index}) => {
        let checkIndex = this.checkSelect(item, index);
        // let {result} = store.getState().reducerSplashSatiaScreen.resultsShahrdar
        let idx = container.state.arraySelected.findIndex(obj => obj.index === index);

        return <View
            onPress={() => {

            }
            }
            style={{
                paddingHorizontal: moderateScale(3),
                backgroundColor: checkIndex ? Colors.colorPrimary : Colors.white,
                borderRadius: moderateScale(4),
                marginHorizontal: moderateScale(2)
            }}
        >
            <View style={[{
                //marginVertical: moderateScale(15),
                height: moderateScale(30),
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'row'
            }]}>
                {/*<HMTextView text={item.name} type={(this.props.position === index) ? "bold" : "normal"}*/}
                {/*style={(this.props.position === index) ? styles.selectedTextStyle : styles.textStyle}/> */}
                {
                    checkIndex ?

                        <View style={{flexDirection: 'row'}}>


                            <TouchableOpacity
                                onPress={() => {
                                    //  let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
                                    let arr = container.state.arraySelected;

                                    if (idx !== -1) {
                                        arr.splice(idx, 1)

                                        container.setState({
                                                arraySelected: arr,
                                                [`selectFilter${index}`]: {
                                                    value: item.name,
                                                    id: item.id,
                                                    type: item.type
                                                },
                                                visibleModal: '',
                                            },

                                            () => {
                                                container.getData(1)
                                            }
                                        )
                                    }
                                    // container.setState({
                                    //         [`selectFilter${index}`]: {
                                    //             value: item.name,
                                    //             id: item.id,
                                    //             type:item.type
                                    //         },
                                    //         visibleModal: '',
                                    //     },
                                    //     () => {
                                    //         let arr = this.state.arraySelected;
                                    //         this.setState({
                                    //                 arraySelected: arr
                                    //             },
                                    //             () => {
                                    //                 container.getData(1)
                                    //             }
                                    //         )
                                    //
                                    //     }
                                    // )

                                }}
                                style={{
                                    alignSelf: 'center',
                                    //  marginHorizontal:moderateScale(6)
                                }}>
                                <HMIcon name={"md-close"} style={{
                                    fontSize: moderateScale(20),
                                    color: '#f2f2f2'
                                }}/>

                            </TouchableOpacity>
                        </View>
                        :
                        null


                }
                {
                    checkIndex ?
                        <View style={{width: moderateScale(6),}}/>

                        :
                        null
                }
                <TouchableOpacity
                    onPress={() => {

                        this.setState({
                                indexFilter: index,
                                typeFilter: item.type,
                                ["dataSource" + index]: item.list
                            },
                            () => {
                                //  this.onShow(item.type == 2 ? 'Operational_Unit' : 'Condition')
                                this.onShow('Modal')

                            })
                    }
                    }

                    style={{alignItems: 'center', flexDirection: 'row'}}
                >

                    <HMTextView text={this.SelectNameFilter(item, index)} type={"bold"}
                                style={{
                                    color: checkIndex ? Colors.white : Colors.gray,
                                    //marginHorizontal: moderateScale(6),
                                    fontSize: moderateScale(14),
                                    textAlign: 'center',

                                }}/>
                    <HMIcon name={"ios-arrow-down"} style={{
                        fontSize: moderateScale(11),
                        color: checkIndex ? '#f2f2f2' : Colors.gray,
                        marginHorizontal: moderateScale(2),
                        marginTop: moderateScale(3)
                    }}/>
                </TouchableOpacity>


            </View>
            {/*<View style={{height:moderateScale(2),width:'100%',backgroundColor:(this.props.position === index) ? '#17bba4' :'transparent'}}/>*/}

        </View>
    }

    /*  renderItems = ({item, index}) => {
          return <DetailsAdapter
              item={item}
              index={index}
              navigation={this.props.navigation}
              props={this.props.route.params}/>;
      }*/
    handleRefresh = () => {
        if (store.getState().reducerSplashSatiaScreen.Connection) {
            this.getData(1)
        } else {
           // ParentScreen.ShowMessageBack(i18n.t('constant.CheckYourInternet'))
        }


        //  this.props.callService(urlListOnlineChargingHistorySatiaScreen, `?type=${this.props.typee}&city=`, TypeGetListOnlineChargingHistorySatiaScreen, 'POST', 1)
    }

    renderFooter() {

        if (this.props.failed === false) {
            return this.props.lazyload_end || this.props.page === 0 ? null :

                <ActivityIndicator color={Colors.colorPrimary} size={"large"}/>


        } else {
            return (
                <HMButton
                    text={i18n.t('constant.retry')}
                    style={styles.buttonModalStyle}
                    onPress={() =>
                        this.getData(this.props.page)
                    }

                />
            );
        }
    }

    handleLoadMore() {
        if (this.props.results.length > 0 && this.props.lazyload_end !== true && this.props.showLoading !== true && store.getState().reducerSplashSatiaScreen.Connection) {
            // this.props.callService(urlListOnlineChargingHistorySatiaScreen, `?type=${this.props.typee}&Condition=`, TypeGetListOnlineChargingHistorySatiaScreen, 'POST', this.props.page)
            if (this.props.page === 0)
                this.getData(1)
            else
                this.getData(this.props.page)
        }
    }

    onChange(index, data) {

        let idx = container.state.arraySelected.findIndex(obj => obj.index === container.state.indexFilter);
        let arr = container.state.arraySelected;

        if (idx !== -1) {
            arr.splice(idx, 1)

            container.setState({
                    arraySelected: arr
                },

                () => {
                    //  container.state.arraySelected.slice(container.state.indexFilter, 1)
                    container.state.arraySelected.push({
                        index: container.state.indexFilter,
                        data: data,
                        id: data.id,
                        value: data.name,
                        type: container.state.typeFilter
                    })
                }
            )

        } else {
            container.state.arraySelected.push({
                index: container.state.indexFilter,
                data: data,
                id: data.id,
                value: data.name,
                type: container.state.typeFilter
            })
            // arr = [...newState.listFilter, {...action.data}]
            // newState.listFilter = arr
        }

        let l = container.state.indexFilter

        container.setState({
                [`selectFilter${l}`]: {value: data.name, id: data.id, type: container.state.typeFilter},
                //indexFilterCondition: index,
                visibleModal: '',
            },
            () => {
                container.getData(1)
            }
        )
    }


    hiddenModal() {
        container.setState({
                visibleModal: ''
            },
            () => {
            })
    }

    onShow(data) {
        container.setState({
            visibleModal: data,

        });
    }

    SearchFilterFunction(data, name, text, childFilter) {
        // let dataSource = "dataSource" + data
        // const newData = this.state[data].filter(function (item) {
        //     const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
        //     const textData = text.toUpperCase()
        //     return itemData.indexOf(textData) > -1
        // })
        // this.setState({
        //         [dataSource]: newData,
        //         //dataSource: newData,
        //         [name]: text
        //     },
        //     () => {
        //     })
        //

        let dataSource = "dataSource" + this.state.indexFilter;
        name = name + this.state.indexFilter;
        const newData = childFilter.list.filter(function (item) {
            const itemData = item.name ? item.name.toUpperCase() : item.sleep_number.toUpperCase()
            const textData = text.toUpperCase()
            return itemData.indexOf(textData) > -1
        })
        this.setState({
                [dataSource]: newData,
                //dataSource: newData,
                [name]: text
            },
            () => {
            })
    }

}
